import Drawer from './Drawer'

/**
 * A dialog: centred across the page and anchored high, not docked at an edge.
 *
 * These were side sheets, on the argument that a centred dialog covers the list
 * you opened it from. That holds for a sheet you work ALONGSIDE — picking group
 * members while reading the list — and it is wrong for everything else. A
 * dialog is one question or one short form, and the place a reader looks for
 * one is the middle of the page: welded to the far edge, the eye has to travel
 * to find it and travel back to the row it was about.
 *
 * Anchored toward the top rather than vertically centred, so the panel grows
 * downward from a fixed point. A dialog that gains a validation message then
 * does not move the text you have already read, and a short one does not sit
 * marooned in the middle of a tall screen.
 *
 * Anything with a real form in it belongs on a FormPage instead — this is for
 * what is genuinely a dialog. Drawer is still there for the sheets that earn
 * the edge.
 */
const SIZES = {
  sm: 'md', // the legacy `modal-dialog` — a plain form
  lg: 'lg', // `modal-lg`
  xl: 'xl', // `modal-xl`
  full: 'full', // `modal-fullscreen`
}

export default function Modal({ size = 'sm', ...rest }) {
  return <Drawer dialog size={SIZES[size] ?? 'md'} {...rest} />
}
